import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3dc5630c = () => interopDefault(import('..\\..\\..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _30a6fcd0 = () => interopDefault(import('..\\..\\..\\pages\\advantage.vue' /* webpackChunkName: "pages/advantage" */))
const _5b0526c4 = () => interopDefault(import('..\\..\\..\\pages\\blocProduct.vue' /* webpackChunkName: "pages/blocProduct" */))
const _11806c4d = () => interopDefault(import('..\\..\\..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _12863f07 = () => interopDefault(import('..\\..\\..\\pages\\products.vue' /* webpackChunkName: "pages/products" */))
const _16394912 = () => interopDefault(import('..\\..\\..\\pages\\system.vue' /* webpackChunkName: "pages/system" */))
const _4e9d05ad = () => interopDefault(import('..\\..\\..\\pages\\detail\\1.vue' /* webpackChunkName: "pages/detail/1" */))
const _62a3242f = () => interopDefault(import('..\\..\\..\\pages\\detail\\adv.vue' /* webpackChunkName: "pages/detail/adv" */))
const _480f8b02 = () => interopDefault(import('..\\..\\..\\pages\\detail\\bm.vue' /* webpackChunkName: "pages/detail/bm" */))
const _40cb6c7e = () => interopDefault(import('..\\..\\..\\pages\\detail\\dq.vue' /* webpackChunkName: "pages/detail/dq" */))
const _7e90b555 = () => interopDefault(import('..\\..\\..\\pages\\detail\\fpc.vue' /* webpackChunkName: "pages/detail/fpc" */))
const _39bfabfe = () => interopDefault(import('..\\..\\..\\pages\\detail\\fs.vue' /* webpackChunkName: "pages/detail/fs" */))
const _4b6d6a34 = () => interopDefault(import('..\\..\\..\\pages\\detail\\g3d.vue' /* webpackChunkName: "pages/detail/g3d" */))
const _3639cbbe = () => interopDefault(import('..\\..\\..\\pages\\detail\\gt.vue' /* webpackChunkName: "pages/detail/gt" */))
const _2cc20112 = () => interopDefault(import('..\\..\\..\\pages\\detail\\jm.vue' /* webpackChunkName: "pages/detail/jm" */))
const _3c1f43e4 = () => interopDefault(import('..\\..\\..\\pages\\detail\\jmdzypzz.vue' /* webpackChunkName: "pages/detail/jmdzypzz" */))
const _2c18e706 = () => interopDefault(import('..\\..\\..\\pages\\detail\\js.vue' /* webpackChunkName: "pages/detail/js" */))
const _22d97a5e = () => interopDefault(import('..\\..\\..\\pages\\detail\\mj.vue' /* webpackChunkName: "pages/detail/mj" */))
const _627f4462 = () => interopDefault(import('..\\..\\..\\pages\\detail\\mjzzzx.vue' /* webpackChunkName: "pages/detail/mjzzzx" */))
const _5344f87d = () => interopDefault(import('..\\..\\..\\pages\\detail\\qcjczx.vue' /* webpackChunkName: "pages/detail/qcjczx" */))
const _0e5f52ea = () => interopDefault(import('..\\..\\..\\pages\\detail\\sj.vue' /* webpackChunkName: "pages/detail/sj" */))
const _0d61abd8 = () => interopDefault(import('..\\..\\..\\pages\\detail\\ss.vue' /* webpackChunkName: "pages/detail/ss" */))
const _02b8dd3f = () => interopDefault(import('..\\..\\..\\pages\\detail\\yd.vue' /* webpackChunkName: "pages/detail/yd" */))
const _03299947 = () => interopDefault(import('..\\..\\..\\pages\\detail\\yl.vue' /* webpackChunkName: "pages/detail/yl" */))
const _039a554f = () => interopDefault(import('..\\..\\..\\pages\\detail\\yt.vue' /* webpackChunkName: "pages/detail/yt" */))
const _04faa0e8 = () => interopDefault(import('..\\..\\..\\pages\\detail\\zn.vue' /* webpackChunkName: "pages/detail/zn" */))
const _00d5293f = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _3dc5630c,
    name: "about"
  }, {
    path: "/advantage",
    component: _30a6fcd0,
    name: "advantage"
  }, {
    path: "/blocProduct",
    component: _5b0526c4,
    name: "blocProduct"
  }, {
    path: "/contact",
    component: _11806c4d,
    name: "contact"
  }, {
    path: "/products",
    component: _12863f07,
    name: "products"
  }, {
    path: "/system",
    component: _16394912,
    name: "system"
  }, {
    path: "/detail/1",
    component: _4e9d05ad,
    name: "detail-1"
  }, {
    path: "/detail/adv",
    component: _62a3242f,
    name: "detail-adv"
  }, {
    path: "/detail/bm",
    component: _480f8b02,
    name: "detail-bm"
  }, {
    path: "/detail/dq",
    component: _40cb6c7e,
    name: "detail-dq"
  }, {
    path: "/detail/fpc",
    component: _7e90b555,
    name: "detail-fpc"
  }, {
    path: "/detail/fs",
    component: _39bfabfe,
    name: "detail-fs"
  }, {
    path: "/detail/g3d",
    component: _4b6d6a34,
    name: "detail-g3d"
  }, {
    path: "/detail/gt",
    component: _3639cbbe,
    name: "detail-gt"
  }, {
    path: "/detail/jm",
    component: _2cc20112,
    name: "detail-jm"
  }, {
    path: "/detail/jmdzypzz",
    component: _3c1f43e4,
    name: "detail-jmdzypzz"
  }, {
    path: "/detail/js",
    component: _2c18e706,
    name: "detail-js"
  }, {
    path: "/detail/mj",
    component: _22d97a5e,
    name: "detail-mj"
  }, {
    path: "/detail/mjzzzx",
    component: _627f4462,
    name: "detail-mjzzzx"
  }, {
    path: "/detail/qcjczx",
    component: _5344f87d,
    name: "detail-qcjczx"
  }, {
    path: "/detail/sj",
    component: _0e5f52ea,
    name: "detail-sj"
  }, {
    path: "/detail/ss",
    component: _0d61abd8,
    name: "detail-ss"
  }, {
    path: "/detail/yd",
    component: _02b8dd3f,
    name: "detail-yd"
  }, {
    path: "/detail/yl",
    component: _03299947,
    name: "detail-yl"
  }, {
    path: "/detail/yt",
    component: _039a554f,
    name: "detail-yt"
  }, {
    path: "/detail/zn",
    component: _04faa0e8,
    name: "detail-zn"
  }, {
    path: "/",
    component: _00d5293f,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
